import styles from "../styles/module/menu.module.css"
import HTMLFlipBook from 'react-pageflip';

import Footer, {getWindowDimensions} from "../components/Footer.jsx";
import React, {useCallback, useEffect, useState} from "react";
import '../styles/Menu.css';
import gsap from "gsap";
import {Swiper, SwiperSlide} from "swiper/react";
import {A11y, Autoplay, EffectFade, Navigation, Pagination, Scrollbar} from "swiper/modules";

function Menu(props) {
    let urls = [
"assets/menu/menu-kando/1.jpg" ,
"assets/menu/menu-kando/2.jpg" ,
"assets/menu/menu-kando/3.jpg" ,
"assets/menu/menu-kando/4.jpg" ,
"assets/menu/menu-kando/5.jpg" ,
"assets/menu/menu-kando/6.jpg" ,
"assets/menu/menu-kando/7.jpg" ,
"assets/menu/menu-kando/8.jpg" ,
"assets/menu/menu-kando/9.jpg" ,
"assets/menu/menu-kando/10.jpg",
"assets/menu/menu-kando/11.jpg",
"assets/menu/menu-kando/12.jpg",
"assets/menu/menu-kando/13.jpg",
"assets/menu/menu-kando/14.jpg",
"assets/menu/menu-kando/15.jpg",
"assets/menu/menu-kando/16.jpg",
"assets/menu/menu-kando/17.jpg",
"assets/menu/menu-kando/18.jpg",
"assets/menu/menu-kando/19.jpg",
"assets/menu/menu-kando/20.jpg",
"assets/menu/menu-kando/21.jpg",
"assets/menu/menu-kando/22.jpg",
"assets/menu/menu-kando/23.jpg",
"assets/menu/menu-kando/24.jpg",
"assets/menu/menu-kando/25.jpg",
"assets/menu/menu-kando/26.jpg",
"assets/menu/menu-kando/27.jpg",
"assets/menu/menu-kando/28.jpg",
"assets/menu/menu-kando/29.jpg",
"assets/menu/menu-kando/30.jpg",
"assets/menu/menu-kando/31.jpg",
"assets/menu/menu-kando/32.jpg",
"assets/menu/menu-kando/33.jpg",
"assets/menu/menu-kando/34.jpg",
"assets/menu/menu-kando/35.jpg",
"assets/menu/menu-kando/36.jpg",
"assets/menu/menu-kando/37.jpg",
              ]
    ;
    let isMobile = false;
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    if (windowDimensions?.width <= 1240) {
        isMobile = true
    }



    useEffect(() => {
        let effectStyle = {
            opacity: 1,
            x: 0,
            y: 0,
            ease: "power3.inOut",
            delay: 0.4,
            stagger: 0.2
        }


        gsap.to(".swiper > .swiper-button-next-custom", 2, {...effectStyle, x: -10})
        gsap.to(".swiper > .swiper-button-prev-custom", 2, effectStyle)
    }, [isMobile])

    return (

            <>
                <div className={styles.bgWood}>
                    <div className={styles.menuFood}>
                        <section className={styles.wrapper}>
                            <div className={styles.top}>Speisekarte</div>
                            <div className={styles.bottom} aria-hidden="true">Speisekarte</div>
                        </section>
                        <ComingSoonMenu/>
                        {/*{*/}
                        {/*    !isMobile ? (*/}
                        {/*        <HTMLFlipBook*/}
                        {/*            width={600}*/}
                        {/*            height={800}*/}
                        {/*            minWidth={350}*/}
                        {/*            maxWidth={1000}*/}
                        {/*            minHeight={420}*/}
                        {/*            maxHeight={1350}*/}
                        {/*            showCover={true}*/}

                        {/*            flippingTime={1000}*/}

                        {/*            maxShadowOpacity={0.5}*/}
                        {/*            className="album-web"*/}
                        {/*        >*/}

                        {/*            {urls.map((url, index) => {*/}
                        {/*                let number = index + 1;*/}
                        {/*                return (*/}

                        {/*                    <Page number={number}>*/}
                        {/*                        <img src={url} alt=""/>*/}
                        {/*                    </Page>*/}
                        {/*                )*/}
                        {/*            })}*/}

                        {/*        </HTMLFlipBook>*/}
                        {/*    ) : <Swiper*/}
                        {/*        spaceBetween={50}*/}
                        {/*        modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade]}*/}
                        {/*        slidesPerView={1}*/}

                        {/*        effect={"creative"}*/}
                        {/*        loop={true}*/}
                        {/*        speed={1500}*/}
                        {/*        navigation={{*/}
                        {/*            nextEl: '.swiper-button-next-custom',*/}
                        {/*            prevEl: '.swiper-button-prev-custom'*/}
                        {/*        }}*/}
                        {/*        pagination={false}*/}
                        {/*        scrollbar={{*/}
                        {/*            el: '.swiper-scrollbar-custom',*/}
                        {/*            draggable: true,*/}
                        {/*            dragSize: 170*/}
                        {/*        }}*/}
                        {/*        onSwiper={(swiper) => {*/}
                        {/*        }}*/}

                        {/*    >*/}

                        {/*        {*/}
                        {/*            urls.map((url, index) => {*/}

                        {/*                return (*/}
                        {/*                    <SwiperSlide>*/}
                        {/*                        <div className={"menu-img"}>*/}
                        {/*                            <img src={url} alt=""/>*/}
                        {/*                        </div>*/}
                        {/*                    </SwiperSlide>*/}
                        {/*                )*/}
                        {/*            })*/}
                        {/*        }*/}
                        {/*        <div className="swiper-pagination"></div>*/}

                        {/*        <div className="swiper-button-prev-custom">*/}
                        {/*            PREV*/}
                        {/*        </div>*/}
                        {/*        <div className="swiper-button-next-custom">*/}
                        {/*            NEXT*/}
                        {/*        </div>*/}
                        {/*    </Swiper>*/}
                        {/*}*/}
                    </div>
                    <img src="/assets/images/shape-6.png" loading="lazy" alt="shape"
                         className={`${styles.shape} ${styles.shape2} ${styles.moveAnim}`}/>
                    <img src="/assets/images/shape-5.png" loading="lazy" alt="shape"
                         className={`${styles.shape} ${styles.shape1} ${styles.moveAnim}`}/>
                    <div className={styles.menuTextCenter}>Im Winter täglich von <span className={styles.strong}>11.30Uhr</span> bis <span className={styles.strong}>22.00Uhr</span></div>
                </div>

            </>

    )


}
const ComingSoonMenu = () => {
    return (
        <div className={styles.container}>
            <div className={styles.menuBox}>
                <h1 className={styles.title}>Menu</h1>
                <p className={styles.message}>
                    Menu wird in Kürze aktualisiert
                </p>
                <div className={styles.icon}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

const Page = React.forwardRef((props, ref) => {
    return (
        <div className="page" ref={ref}>

            <div className="page-content">
                {props.children}
            </div>
            <p>{props.number}</p>
        </div>
    );
});
export default Menu;